import type { CommunityInsights } from '@researcher/shared';
import { apiUrl } from '../config/api';

export async function fetchCommunityInsights(): Promise<CommunityInsights | null> {
  const response = await fetch(apiUrl('/community/insights'));
  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Failed to fetch community insights');
  }

  return data.data || null;
}
